

if(typeof Swiper !== 'undefined'){
   
  //      TIMELINE FUNCTIONALITY      //

  var troxyTimelineNav = new Swiper(".troxy-timeline__nav", {
      direction: "horizontal",
      spaceBetween: 0,
      slidesPerView: 6,
      freeMode: false,
      watchSlidesProgress: true,
      mousewheel: true,
      centeredSlides: true,
        breakpoints: {
          950: {
            direction: "vertical",
            slidesPerView: 7,
          },
      },
      on: {
        slideChange: function () {

          // Scroll timeline event into view according to active date.
          // Solves issue when scrolling through dates as it wouldn't update the timeline itself
          const timelineSwiper = document.querySelector('.troxy-timeline__list');
          timelineSwiper.swiper.slideTo(this.activeIndex);

          // Get custom select element
          const jumpToSelect = document.querySelector('.troxy-custom-select');
          // Find active slide
          const activeSlide = this.slides.filter(slide => slide.classList.contains('swiper-slide-thumb-active'))[0];
      
          jumpToSelect.innerHTML = activeSlide.innerText.slice(0,3) + "0s";
          jumpToSelect.classList.add('center-text');
        }
      } 
    });

    var troxyTimelineList = new Swiper(".troxy-timeline__list", {
      direction: "vertical",
      slidesPerView: 1,
      spaceBetween: 50,
      mousewheel: true,
      autoHeight: false,
      watchOverflow: false,
      roundLengths: true,
      thumbs: {
        swiper: troxyTimelineNav
      },
      on: {
        slideChange: function (swiper) {

          // Scroll active thumb slide to center it
          this.thumbs.swiper.slideTo(this.activeIndex);

          let activeIndex = this.activeIndex + 1;
        
          // Get title from active event
          const year = document.querySelector(`.troxy-timeline__nav .swiper-slide:nth-child(${activeIndex})`).dataset.year
          
          // Set the background date element's innerText to the current title e.g 1930
          const backgroundDate = document.querySelector(`#background_date`);
          backgroundDate.innerText = year;

        }
      } 
    });


    //      CUSTOM SELECT ELEMENT AND FUNCTIONALITY      //

    // Get select dom elements
    const selectWrapper = document.querySelector("#troxy-jump-to-custom-select");

    if(selectWrapper){
    const select = selectWrapper.querySelector('select');
    const selectOptions = [...select.querySelectorAll('option')];

    // Create new div to act as a selected item
    const selected = document.createElement("DIV");
    selected.classList.add("troxy-custom-select", "center-text");
    selected.innerHTML = select.options[select.selectedIndex].innerHTML;
    selectWrapper.appendChild(selected);

    // Create a new div to contain the option list
    const options = document.createElement("DIV");
    options.classList.add('troxy-custom-select__options', 'select-hide');

    // Store previous option value in var to remove duplicates
    let previousValue = '';
    // Loop through all current options
    selectOptions.forEach((item, index) => {
      // Don't render 'Jump to a year'
      if(index === 0) return; 
      // Get first 3 numbers to attribute top decade
      const decade = item.innerHTML.slice(0,3)
      // If option (Year) hasn't already rendered 
      if(decade !== previousValue) {
        // Create div to act as option
        const option = document.createElement("DIV");
        option.innerHTML = decade + "0s";
        option.classList.add('troxy-custom-select__option');
        option.onclick = (e) => handleOptionSelection(e);
        option.dataset.index = item.value;
        option.dataset.slideText = item.innerHTML;
        options.appendChild(option)
      }
      // Popupate previous value with current item html
      previousValue = decade
    })

    selectWrapper.appendChild(options);

    selected.onclick = (e) => toggleSelectActive(e);

    // Once active select box has been clicked, toggle options
    const toggleSelectActive = (e) => {
        e.stopPropagation();

        // Toggle hide and active classes on select elements
        e.target.nextSibling.classList.toggle("select-hide");
        e.target.classList.toggle("select-active");
    }

    // Handle when option has been selected
    const handleOptionSelection = (e) => {
        const selectedOptions = e.target;
        // Get select elements
        const selectWrapper = document.querySelector("#troxy-jump-to-custom-select");
        const select = selectWrapper.querySelector('select');
        const selectOptions = [...select.options];
        const actingSelect = selectedOptions.parentNode.previousSibling;
         
        // Loop through select options
        selectOptions.forEach((item, index) => {
            // Check if option has same innerHTML value as our selected acting element
            if (item.innerHTML == selectedOptions.dataset.slideText) {
                // Change selected index for our our actual select and update acting select with values
                select.selectedIndex = index;
                actingSelect.innerHTML = selectedOptions.innerHTML;
                actingSelect.dataset.index = selectedOptions.dataset.index;
                actingSelect.dataset.slideText = selectedOptions.dataset.slideText;
                actingSelect.classList.add('center-text');
                troxyTimelineNav.slideTo(selectedOptions.dataset.index);  
          }
        })
    }
   
    // Close select element
    const closeSelect = (elmnt) => {
        // Get custom select and options
        const selected = document.querySelector('.troxy-custom-select');
        const selectItems = document.querySelector('.troxy-custom-select__options');
        // Remove active and add hide classes to elements
        selected.classList.remove('select-active'); // This affects the arrow transition
        selectItems.classList.add('select-hide');
    }

    // If user clicks off select element, close select
    document.addEventListener("click", closeSelect);
  }
}